import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { getApiBaseUrl } from "@project/services/shared/config";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Turn API media paths into browser-loadable absolute URLs.
 * Handles absolute http(s)/blob/data URLs and relative `/media/...` paths.
 */
export function resolveMediaUrl(
  url: string | null | undefined
): string | null {
  if (!url || typeof url !== "string") {
    return null;
  }
  const trimmed = url.trim();
  if (!trimmed) {
    return null;
  }
  if (/^(https?:|blob:|data:)/i.test(trimmed)) {
    return trimmed;
  }

  const apiBase = getApiBaseUrl().replace(/\/$/, "");
  // VITE_API_BASE_URL is often `https://host/api` while media lives on host root
  const origin = apiBase.replace(/\/api$/i, "");
  if (!origin) {
    return trimmed.startsWith("/") ? trimmed : `/${trimmed}`;
  }
  if (trimmed.startsWith("/")) {
    return `${origin}${trimmed}`;
  }
  return `${origin}/${trimmed}`;
}
